import { PDFViewFrame } from '@modules/Landing/Shared/Ui/PDFView/PDFViewFrame/PDFViewFrame';
import css from './PDFView.module.css';
import pdfImg from '@assets/Imgs/pdfImg.png';

export const PDFView: React.FC = () => {
    return (
        <div className={css.container}>
            <div className={css.frame}>
                <PDFViewFrame />
            </div>

            <div className={css.redContainer}>
                <img src={pdfImg} className={css.img} />
            </div>
        </div>
    );
};
